import { useState } from "react";
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "./Dialog";
import { Button } from "./Button";

export interface AlertDialogProps {
  title?: string;
  message?: React.ReactNode;
  onSubmit?: () => Promise<void>;
  onAccept?: () => void;
  okLabel?: string;
  open: boolean;
  setOpen: (open: boolean) => void;
  className?: string;
}

export const AlertDialog = ({
  title = "Alert",
  message,
  onSubmit,
  onAccept,
  okLabel = "OK",
  open,
  setOpen,
  className,
}: AlertDialogProps) => {
  const [loading, setLoading] = useState(false);

  if (typeof message === "string") {
    message = <p>{message}</p>;
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className={className}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <div className="my-2">{message}</div>
        </DialogBody>
        <DialogFooter className="justify-center">
          <Button
            className="min-w-20"
            disabled={loading}
            onClick={async () => {
              if (onSubmit) {
                setLoading(true);
                await onSubmit();
                setLoading(false);
              }
              onAccept?.();
              setOpen(false);
            }}
          >
            {okLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
